module.exports = __webpack_public_path__ + "static/media/cards-test.c1ff9b42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/assets-for-demo/cards-test.png
// module id = 1172
// module chunks = 0